import { Component ,Input} from '@angular/core';
import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-review',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './review.component.html',
  styleUrl: './review.component.scss'
})
export class ReviewComponent {

  @Input() name : string =''
  @Input() text : string =''
  @Input() photo : string =''
  @Input() rating : number=0

  get filledStars(): number[] {
    return Array(this.rating).fill(0);
  }

  
  
  get emptyStars(): number[] {
    return Array(5 - this.rating).fill(0);
  }
  

}
